// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ekk-L","title":"styles_title__tb-fg"};